module.exports = __webpack_public_path__ + "23b7a6eeb111cc4546ee06fc585ae051.jpg";